import styles from "./BookDetails.module.css";
import TranslationText from "./TranslationText";
import playIcon from "../images/play-mobile.svg"
import isMobileOrTablet from "../features/common/common.js"

export default function BookDetailsButtons({onClick, book, onDeeplinkClick}) {
    return (<div className={styles.buttons}>
        {
        isMobileOrTablet() && book?.type === "flashcard" ? null : 
        <div className={styles.playButton} onClick={onClick}>
            <img src={playIcon} alt="levelIcon"/>
        </div>
        }
        <div className={styles.deeplink} onClick={onDeeplinkClick}>
            <TranslationText value="open_in_app"/>
        </div>
    </div>);
}
